export default __webpack_public_path__ + "static/media/8841b0a669fab022de4cdaebbea290c8.gif";